// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import arrowNarrowDownIcon from "@/assets/icons/arrow-narrow-down.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ArrowNarrowDownIconProps = Omit<IconProps, "name">;

export function ArrowNarrowDownIcon(props: ArrowNarrowDownIconProps): React.ReactNode {
  return <Icon name={arrowNarrowDownIcon} {...props} />;
}
